export const FETCH_DASHBOARD_STATS_REQUEST = "FETCH_DASHBOARD_STATS_REQUEST";
export const FETCH_DASHBOARD_STATS_SUCCESS = "FETCH_DASHBOARD_STATS_SUCCESS";
export const FETCH_DASHBOARD_STATS_FAILED = "FETCH_DASHBOARD_STATS_FAILED";